<template>
  <div
    v-if="isAlertShown"
    class="
      flex
      p-4
      mb-4
      rounded-lg
      absolute
      right-0
      bottom-0
    "
    role="alert"
    :class="(alertType == 'Success') ? ' text-green-700 bg-green-100 dark:bg-green-200 dark:text-green-800' 
    : (alertType == 'Warning') ? 'text-yellow-700 bg-yellow-100 dark:bg-yellow-200 dark:text-yellow-800' :' text-red-700 bg-red-100 dark:bg-red-200 dark:text-red-800'"
  >
    <svg
      class="inline flex-shrink-0 mr-3 w-5 h-5"
      fill="currentColor"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
        clip-rule="evenodd"
      ></path>
    </svg>
    <div>
      <p class="font-medium">
        <slot name="alert"> This is the default alert! </slot>
      </p>
      <slot name="body"> This is the default body! </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "ConfirmationMessage",
  props: {
    isAlertShown: Boolean,
    alertType:String
  },
};
</script>